export enum PaymentStatus {
	'NotPaid' = 'Not Paid',
	'PaidInFull' = 'Paid in Full',
}
